import LastName from './lastname'

export default LastName
